import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import { T_ } from '@shared/translation';
import tpl from '../templates/fblogin.html';

/*
 * FBLogin view controller: bind the signup view
 * with its model.
 */
export default Backbone.View.extend({
  template: _.template(tpl),

  initialize(options) {
    // Event bus
    this.signupModel = options.signupModel;
    this.vent = options.vent;
    this.$el = $(this.el);
    this.model.bind('change', this.onChange, this);
    this.model.bind('fb:notconnected', this.onNotConnected, this);
    this.model.bind('fb:connected', this.onConnected, this);
    this.model.bind('fb:cancelled', this.onCancelled, this);
    this.signupModel.bind('username:valid', this.onValidUsername, this);
    this.signupModel.bind('username:invalid', this.onInvalidUsername, this);
    this.signupModel.bind('username:available', this.onAvailableUsername,
      this);
    this.model.bind('fb:loginsuccess', this.onLoginSuccess, this);
    this.model.bind('fb:loginerror', this.onLoginError, this);
    this.model.bind('fb:signupsuccess', this.onSignupSuccess, this);
    this.model.bind('fb:signuperror', this.onSignupError, this);
    this.model.bind('fb:redirection', this.onRedirection, this);
  },

  // UI Events
  events: {
    'submit #fb-new-user-form': 'signup',
    'submit #fb-returning-user-form': 'link',
    'click #forgot-password-btn': 'showRecoverPassword',
    'change input[name="user-type"]': 'switchUserType',
    'blur input[name="fb-username"]': 'checkUsername',
    'change input[name="fb-username"]': 'checkUsername',
    'click .close': 'close',
  },

  onNotConnected() {
    this.$el.find('#fb-login-status')
    .text(T_('Please connect to your Facebook account.'));
    this.model.doLogin();
  },

  onConnected() {
    this.$el.find('#fb-login-status')
    .text(T_('Connected to Facebook. Retrieving your information...'));
    this.model.getFBProfileData();
    this.model.getFBProfilePicture();
  },

  onCancelled() {
    this.$el.find('#fb-login-status')
    .text(T_('Please authorize Freelancer.com to access your account.'));
      // Click here to retry?
  },

  onChange() {
    if (this.model.isProfileData()) {
      this.render();
    }
  },

  switchUserType() {
    const userType = this.$el.find('input[name=user-type]:checked')
      .val();
    if (userType == 'new-user') {
      this.$el.find('#fb-returning-user-form').hide();
      this.$el.find('#fb-new-user-form').show();
    } else {
      this.$el.find('#fb-new-user-form').hide();
      this.$el.find('#fb-returning-user-form').show();
    }
  },

    // Username
  checkUsername() {
    const username = this.$el.find('input[name="fb-username"]');
    if (username.val()) {
      this.signupModel.set({
        username: username.val(),
      }, { silent: true });
      this.signupModel.isValidUsername();
    } else {
      username.siblings('.username-error').slideUp().hide();
      username.parent().removeClass('valid-state')
        .removeClass('error-state');
    }
  },

  onInvalidUsername(reason) {
    this.$el.find('#signup_btn').removeClass('processing');
    const username = this.$el.find('input[name="fb-username"]');
    username.siblings('.fb-username-error').text(reason)
      .stop()
      .slideDown();
    username.parent().removeClass('valid-state')
      .addClass('error-state');
  },

  onValidUsername() {
    const username = this.$el.find('input[name="fb-username"]');
    username.siblings('.fb-username-error').slideUp().hide();
    username.parent().removeClass('error-state');
    this.signupModel.isAvailableUsername();
  },

  onAvailableUsername() {
    const username = this.$el.find('input[name="fb-username"]');
    username.parent().addClass('valid-state');
  },

  link(e) {
    e.preventDefault();
    this.$el.find('#login_btn').addClass('processing');
    const username = this.$el.find('input[name="username"]');
    const password = this.$el.find('input[name="password"]');
    username.parent().removeClass('error-state');
    password.parent().removeClass('error-state');
    username.siblings('.username-error').slideUp().hide();
    password.siblings('.password-error').slideUp().hide();
    if (this.$el.find('.login-error').is(':visible')) {
      this.$el.find('.login-error').hide();
    }
    const saveLogin = this.$el.find('input[name="savelogin"]')
      .is(':checked');
    this.model.set({
      username: username.val(),
      password: password.val(),
      save_login: saveLogin,
    }, { silent: true });
    this.model.linkFbAccount();
  },

  signup(e) {
    e.preventDefault();
    this.$el.find('#signup_btn').addClass('processing');
    const username = this.$el.find('input[name="fb-username"]');
    const lookingFor = this.$el.find('input[name="looking_for"]:checked');
    username.parent().removeClass('error-state');
    username.siblings('.fb-username-error').slideUp().hide();
    if (this.$el.find('.signup-error').is(':visible')) {
      this.$el.find('.signup-error').hide();
    }
    this.model.set({
      username: username.val(),
      looking_for: lookingFor.val() == 'Employer' ? 'Employer' : 'Worker',
    }, { silent: true });
    this.model.signupWithFb();
  },

  onLoginSuccess() {
    const msg = T_('Login successful!');
    this.$el.find('.login-success').text(msg)
      .stop()
      .slideDown();
    this.vent.trigger('fblogin:loginsuccess');
  },

  onLoginError(reason) {
    this.$el.find('#login_btn').removeClass('processing');
    this.$el.find('.login-error').text(reason)
      .stop()
      .slideDown();
  },

  onSignupSuccess() {
    const msg = T_('Login successful!');
    this.$el.find('.signup-success').text(msg)
      .stop()
      .slideDown();
    this.vent.trigger('fbsignup:signupsuccess');
  },

  onSignupError(reason) {
    this.$el.find('#signup_btn').removeClass('processing');
    this.$el.find('.signup-error').text(reason)
      .stop()
      .slideDown();
  },

  onRedirection(toURL) {
    const msg = T_('Login successful! Redirecting...');
    this.$el.find('.login-success').text(msg)
      .stop()
      .slideDown();
    this.vent.trigger('fblogin:redirection', { toURL });
  },

    // Render
  render() {
    this.$el.html(this.template({
      model: this.model.toJSON(),
      options: this.options,
      isProfileData: this.model.isProfileData(),
      T_,
    }));
    return this;
  },

  showRecoverPassword() {
    this.vent.trigger('show:recoverpassword', {
      loginModel: this.model,
    });
  },

  close() {
    this.vent.trigger('close');
  },

    /**
     * Destroy the view. Unbind all references to enable the view
     * to be garbage collected and remove the el from the DOM.
     */
  destroy() {
    this.model.unbind('change', this.render, this);
    this.remove();
  },
});
